// rem等比适配配置文件
// 基准大小
const baseSize = 16;
// 设置 rem 函数
function setRem() {
  // 当前页面宽度相对于 1920宽的缩放比例，可根据自己需要修改。
  var t = window.devicePixelRatio; // 获取下载的缩放 125% -> 1.25    150% -> 1.5
  if (t != 1) {
    // 如果进行了缩放，也就是不是1
    console.log(t);
    // document.body.style.zoom = 1.0 / t; // 就去修改页面的缩放比例，这个公式我自己算的，不准确，勉强。
  }
  // const scale = document.documentElement.clientWidth / 1920;
  // // 设置页面根节点字体大小（“Math.min(scale, 2)” 指最高放大比例为2，可根据实际业务需求调整）
  // if (scale < 1) {
  if (window.screen.width < 1200) {
    document.documentElement.style.fontSize = baseSize + 'px';
  } else {
    document.documentElement.style.fontSize = baseSize / t + 'px';
  }
  // } else {
  //   document.documentElement.style.fontSize = baseSize * Math.min(scale, 2) + 'px';
  // }
}
// 初始化
setRem();
// 改变窗口大小时重新设置 rem
window.onresize = function () {
  setRem();
};
